module.exports = __webpack_public_path__ + "img/failicon.65327c79.svg";